export default {
    importManualFamilyCategories: 'IMPORT_MANUAL_FAMILIES_CATEGORIES',
};
